export default {
  nav: {
    technology: "Tecnologia ODF",
    solutions: "Soluções",
    partnerships: "Parcerias",
    about: "Sobre nós",
    contact: "Contacte-nos",
    home: "Início",
  },
  hero: {
    eyebrow: "SOLUÇÕES ODF DE NOVA GERAÇÃO",
    headline1: "Inovação,",
    headline2: "entregue em cada película.",
    copy: "A NORTIS leva películas orodispersíveis (Orally Dissolving Films, ODF) avançadas às marcas de bem-estar modernas e aos mercados internacionais — combinando um formato prático com uma sólida experiência comercial.",
    cta1: "Explorar a tecnologia ODF",
    cta2: "Ser parceiro da NORTIS",
    trust: "Concebido para estilos de vida modernos. Criado para oportunidades globais.",
    scroll: "Deslizar",
  },
  brandline: "Entrega avançada. Experiência sem esforço.",
  credibility: {
    title: "Um formato mais inteligente para um mundo em mudança.",
    copy: "As películas orodispersíveis oferecem uma forma refinada e prática de administrar ingredientes cuidadosamente formulados — sem a experiência convencional de comprimidos, cápsulas ou líquidos.",
  },
  whatIsOdf: {
    eyebrow: "O FORMATO",
    title: "O que é uma ODF?",
    copy: "A ODF é uma película oral ultrafina concebida para se dissolver comodamente na boca. O seu formato compacto oferece uma alternativa moderna às marcas que desenvolvem experiências de bem-estar portáteis e fáceis de utilizar.",
    benefits: [
      { title: "Fina e portátil", desc: "Um formato ultrafino que viaja sem esforço — num bolso, numa carteira ou numa mala." },
      { title: "Utilização sem água", desc: "Concebida para ser utilizada em qualquer lugar e a qualquer momento, sem água nem preparação." },
      { title: "Apresentação precisa", desc: "Cada película é uma unidade apresentada individualmente, embalada para garantir consistência." },
      { title: "Feita para a inovação", desc: "Uma base flexível para conceitos de produto modernos e experiências de marca diferenciadas." },
    ],
  },
  whyNortis: {
    eyebrow: "PORQUÊ A NORTIS",
    title: "Mais do que um formato de produto. Uma oportunidade de mercado completa.",
    copy: "A NORTIS é a ponte entre a inovação em ODF e os mercados comerciais — ligando produtos promissores aos parceiros capazes de os escalar.",
    points: [
      { title: "Experiência comercial focada em ODF", desc: "Um foco dedicado à categoria das películas orodispersíveis e à sua dinâmica comercial." },
      { title: "Sourcing internacional e desenvolvimento de mercados", desc: "Identificar oportunidades e construir vias de acesso ao mercado em diferentes regiões." },
      { title: "Apoio ao posicionamento de produto e marca", desc: "Ajudamos os parceiros a adaptar os conceitos ODF aos seus públicos e canais." },
      { title: "Modelos de parceria B2B flexíveis", desc: "Distribuição, marca própria e desenvolvimento de mercados — estruturados em função dos seus objetivos." },
      { title: "Seleção orientada para a qualidade", desc: "Avaliação rigorosa da adequação, da documentação e da preparação para o mercado." },
      { title: "Relações de longo prazo", desc: "Parcerias construídas para um crescimento comercial duradouro e cumulativo." },
    ],
  },
  solutions: {
    eyebrow: "PORTEFÓLIO DE SOLUÇÕES",
    title: "Um portefólio desenhado em torno da vida moderna.",
    copy: "Explore as categorias de soluções que a NORTIS desenvolve com parceiros e mercados em todo o mundo.",
    viewAll: "Ver todas as soluções",
    requestInfo: "Solicitar informações do produto",
    possibilitiesLabel: "Possibilidades de desenvolvimento",
    positioningLabel: "Posicionamento comercial",
    availabilityLabel: "Disponibilidade no mercado",
    targetLabel: "Mercado-alvo",
    docLabel: "Estado da documentação",
    sheetLabel: "Ficha informativa",
    sheetOnRequest: "Disponível mediante pedido",
    demoBadge: "Conceito de demonstração",
    filterAll: "Todas",
    pageTitle: "Soluções",
    pageSub: "Um portefólio filtrável de categorias de soluções ODF — estruturado para integrar produtos reais à medida que as parcerias evoluem.",
    demoNote: "As entradas abaixo são conceitos de demonstração que ilustram a direção de cada categoria. Os produtos comerciais reais são apresentados no âmbito de parcerias ativas.",
  },
  comparison: {
    eyebrow: "EXPERIÊNCIA DO FORMATO",
    title: "Como o formato de película se compara.",
    copy: "Um olhar neutro sobre as características práticas dos formatos do dia a dia.",
    note: "Comparação neutra apenas das características práticas do formato. Não constitui qualquer afirmação de desempenho clínico ou eficácia.",
    formats: ["Película ODF", "Comprimidos", "Cápsulas", "Líquidos"],
    rows: [
      { label: "Portabilidade", values: [2, 2, 2, 0] },
      { label: "Utilização sem água", values: [2, 0, 0, 1] },
      { label: "Formato individual pré-doseado", values: [2, 2, 2, 0] },
      { label: "Facilidade de armazenamento", values: [2, 2, 1, 0] },
      { label: "Experiência discreta em movimento", values: [2, 1, 1, 0] },
    ],
  },
  models: {
    eyebrow: "MODELOS DE PARCERIA",
    title: "Três formas de crescer com a NORTIS.",
    cta: "Conversar sobre uma parceria",
    items: [
      { title: "Distribuição", desc: "Leve produtos ODF selecionados a novos territórios e redes comerciais." },
      { title: "Marca própria", desc: "Desenvolva conceitos ODF diferenciados sob a sua própria marca." },
      { title: "Desenvolvimento de mercados", desc: "Construa com a NORTIS o posicionamento do produto, a estratégia de lançamento e uma presença de mercado duradoura." },
    ],
  },
  timeline: {
    eyebrow: "COMO FUNCIONA A COLABORAÇÃO",
    title: "Da primeira conversa ao crescimento no mercado.",
    steps: [
      { title: "Descoberta de oportunidades", desc: "Exploramos os seus objetivos, os seus mercados e os conceitos ODF que melhor se adequam." },
      { title: "Alinhamento de produto e mercado", desc: "Combinamos os produtos certos com o contexto comercial certo." },
      { title: "Avaliação comercial", desc: "Estruturamos condições, volumes e um enquadramento comercial realista." },
      { title: "Conformidade e preparação do lançamento", desc: "Revemos a documentação e os requisitos do mercado antes do lançamento." },
      { title: "Distribuição e crescimento", desc: "Apoiamos a implementação, a expansão e o crescimento da parceria a longo prazo." },
    ],
  },
  quality: {
    eyebrow: "QUALIDADE E RESPONSABILIDADE",
    title: "A qualidade começa com as perguntas certas.",
    copy: "A NORTIS avalia a adequação do produto, a documentação, a preparação comercial e os requisitos de mercado no âmbito de cada potencial parceria. A disponibilidade dos produtos e o seu estatuto regulamentar podem variar consoante o país.",
    placeholder: "A documentação de qualidade verificada e as certificações serão publicadas aqui à medida que as parcerias evoluírem.",
  },
  global: {
    eyebrow: "VISÃO GLOBAL",
    title: "Criados para a colaboração internacional",
    copy: "Trabalhamos com marcas, fornecedores, distribuidores e parceiros comerciais para identificar oportunidades ODF relevantes em mercados globais em constante evolução.",
  },
  finalCta: {
    title: "Vamos moldar juntos a próxima geração do bem-estar oral.",
    copy: "Quer esteja a explorar a distribuição, a marca própria ou um novo conceito de produto ODF, a NORTIS está pronta para iniciar a conversa.",
    cta: "Iniciar uma conversa",
  },
  footer: {
    desc: "A NORTIS liga produtos ODF inovadores a marcas, parceiros e mercados em todo o mundo.",
    nav: "Navegação",
    legal: "Legal",
    privacy: "Política de Privacidade",
    terms: "Termos de Utilização",
    language: "Idioma",
    disclaimer: "A disponibilidade, formulação, classificação e estatuto regulamentar dos produtos podem variar consoante o país. As informações deste website destinam-se a fins comerciais e de informação geral e não constituem aconselhamento médico.",
    rights: "Todos os direitos reservados.",
  },
  tech: {
    eyebrow: "TECNOLOGIA ODF",
    title: "A ciência do ultrafino.",
    sub: "Uma perspetiva educativa sobre a película orodispersível — o formato, a experiência e as possibilidades comerciais que abre.",
    what: {
      title: "O que é uma película orodispersível?",
      copy: "Uma película orodispersível (ODF) é uma lâmina ultrafina concebida para se dissolver comodamente na boca. Em vez de engolir um comprimido ou medir um líquido, o utilizador coloca simplesmente uma película e deixa-a dissolver-se — uma experiência discreta e moderna num formato notavelmente compacto.",
    },
    structure: {
      title: "A estrutura geral da película",
      copy: "Conceptualmente, uma ODF combina uma base estrutural, uma matriz transportadora que contém os ingredientes formulados e uma camada sensorial que define o sabor e a textura. Passe o cursor ou toque no diagrama para separar as camadas conceptuais.",
      note: "Representação conceptual, apenas para fins ilustrativos.",
      layers: [
        { title: "Camada sensorial", desc: "Define o sabor, a textura e a experiência de dissolução." },
        { title: "Matriz transportadora", desc: "Contém os ingredientes cuidadosamente formulados no interior da película." },
        { title: "Base estrutural", desc: "Confere à película a sua integridade, finura e estabilidade." },
      ],
    },
    experience: {
      title: "A experiência do utilizador",
      copy: "Sem água. Sem medições. Sem interrupções. A película dissolve-se discretamente, tornando natural a sua utilização em viagem, no trabalho ou em movimento. Para os consumidores modernos, o próprio formato torna-se parte da experiência de marca.",
    },
    portability: {
      title: "Portabilidade e potencial de embalagem",
      copy: "As películas individuais podem ser apresentadas em saquetas finas, elegantes embalagens múltiplas ou dispensadores compactos — formatos que se adequam tanto às prateleiras do retalho moderno como aos momentos de unboxing da venda direta ao consumidor.",
    },
    development: {
      title: "Possibilidades de desenvolvimento de produto",
      copy: "O formato de película suporta uma vasta gama de conceitos de produto — desde rotinas diárias de bem-estar a posicionamentos de estilo de vida específicos — dando às marcas espaço para se diferenciarem em categorias saturadas.",
    },
    commercial: {
      title: "Aplicações comerciais",
      copy: "Os conceitos ODF estão a ser desenvolvidos nas categorias de bem-estar, beleza de dentro para fora, energia, sono e ingredientes funcionais — canais onde a conveniência e a experiência premium orientam as decisões de compra.",
    },
    regulatory: {
      title: "Considerações de mercado e regulamentares",
      copy: "A classificação e os requisitos aplicáveis aos produtos em formato de película diferem consoante o país e a formulação. A NORTIS aborda cada mercado individualmente, analisando a documentação e o contexto regulamentar com os parceiros antes da comercialização.",
    },
    cta: "Solicitar informações técnicas",
  },
  partnership: {
    eyebrow: "MARCA PRÓPRIA E DISTRIBUIÇÃO",
    title: "Dois caminhos. Um único padrão de parceria.",
    sub: "A NORTIS estrutura as colaborações comerciais em torno de dois modelos principais — ambos concebidos para a clareza, a rapidez e o crescimento a longo prazo.",
    plTitle: "Marca própria",
    plDesc: "Desenvolva conceitos ODF diferenciados sob a sua própria marca, com a NORTIS a coordenar o percurso do conceito até à prateleira.",
    plSteps: ["Avaliação do conceito", "Seleção de produtos", "Coordenação de marca e embalagem", "Revisão da documentação", "Preparação do lançamento", "Escalada comercial"],
    distTitle: "Distribuição",
    distDesc: "Leve produtos ODF selecionados para o seu território e a sua rede comercial, com apoio estruturado em cada etapa.",
    distSteps: ["Avaliação do território", "Alinhamento do portefólio", "Condições comerciais", "Planeamento da entrada no mercado", "Apoio ao lançamento", "Crescimento a longo prazo"],
    formTitle: "Iniciar um pedido de parceria",
    formSub: "Fale-nos dos seus objetivos e a nossa equipa responderá com os próximos passos.",
  },
  about: {
    eyebrow: "SOBRE A NORTIS",
    title: "Focados no formato que moldará o amanhã.",
    copy: "A NORTIS foi criada para ligar inovações ODF promissoras às marcas, aos parceiros e aos mercados capazes de as transformar em produtos comerciais relevantes. Combinamos rapidez empreendedora, visão internacional e uma abordagem disciplinada às parcerias de longo prazo.",
    positioning: "A NORTIS liga produtos ODF inovadores a marcas, parceiros e mercados em todo o mundo.",
    principlesTitle: "Os nossos princípios",
    principles: [
      { title: "Precisão", desc: "Cuidado em cada detalhe — da avaliação do produto à comunicação com os parceiros." },
      { title: "Confiança", desc: "Expectativas transparentes e compromissos que tencionamos cumprir." },
      { title: "Progresso", desc: "Uma orientação clara para o avanço e para os formatos modernos." },
      { title: "Parceria", desc: "Relações concebidas para crescer ao longo de anos, não de trimestres." },
      { title: "Perspetiva global", desc: "Pensar para além de fronteiras, mercados e culturas de consumo." },
    ],
  },
  contact: {
    eyebrow: "CONTACTO",
    title: "Vamos iniciar a conversa.",
    sub: "Partilhe alguns detalhes sobre o seu interesse e a nossa equipa entrará em contacto consigo.",
    name: "Nome completo",
    company: "Empresa",
    email: "E-mail profissional",
    country: "País",
    website: "Website",
    interest: "Interesse de parceria",
    market: "Mercado ou território previsto",
    message: "Mensagem",
    consent: "Autorizo a NORTIS a guardar os meus dados para responder a este pedido.",
    submit: "Enviar mensagem",
    sending: "A enviar…",
    successTitle: "Obrigado — a sua mensagem foi recebida.",
    successCopy: "A nossa equipa irá analisar o seu pedido e entrará em contacto consigo brevemente.",
    successAnother: "Enviar outra mensagem",
    errorRequired: "Este campo é obrigatório.",
    errorEmail: "Introduza um e-mail profissional válido.",
    errorConsent: "É necessário o seu consentimento para submeter o formulário.",
    errorSubmit: "Ocorreu um erro. Tente novamente.",
    optional: "Opcional",
    interests: {
      distribution: "Distribuição",
      privateLabel: "Marca própria",
      sourcing: "Sourcing de produtos",
      marketDev: "Desenvolvimento de mercados",
      general: "Parceria geral",
      product: "Informações de produto",
      technical: "Informações técnicas",
    },
    selectPlaceholder: "Selecione uma opção",
  },
  legal: {
    privacyTitle: "Política de Privacidade",
    termsTitle: "Termos de Utilização",
    updated: "Última atualização",
    privacy: [
      { h: "1. Visão geral", p: "Esta Política de Privacidade explica como a NORTIS recolhe, utiliza e protege as informações submetidas através deste website. Comprometemo-nos a tratar os dados de contacto profissionais de forma responsável e transparente." },
      { h: "2. Informações que recolhemos", p: "Quando submete um formulário de contacto ou de parceria, recolhemos as informações que fornece, como o nome, a empresa, o e-mail profissional, o país, o website, a área de interesse e o conteúdo da mensagem." },
      { h: "3. Como utilizamos as informações", p: "As informações submetidas são utilizadas exclusivamente para responder ao seu pedido, avaliar uma potencial colaboração comercial e comunicar consigo sobre assuntos de parceria relevantes. Não vendemos dados pessoais." },
      { h: "4. Armazenamento e segurança dos dados", p: "As submissões de formulários são armazenadas de forma segura na base de dados da nossa aplicação. O acesso está limitado ao pessoal que dele necessita para responder aos pedidos. Adotamos medidas técnicas razoáveis para proteger os dados armazenados." },
      { h: "5. Conservação dos dados", p: "Conservamos os dados dos pedidos durante o tempo necessário à gestão da relação comercial ou conforme exigido pela legislação aplicável. Pode solicitar a eliminação dos seus dados contactando-nos." },
      { h: "6. Os seus direitos", p: "Dependendo da sua jurisdição, poderá ter o direito de aceder, retificar ou eliminar os dados pessoais que conservamos sobre si. Para exercer estes direitos, contacte-nos através do website." },
      { h: "7. Alterações a esta política", p: "Podemos atualizar esta Política de Privacidade periodicamente. As alterações relevantes serão refletidas nesta página com uma data de revisão atualizada." },
    ],
    terms: [
      { h: "1. Aceitação dos termos", p: "Ao aceder e utilizar este website, aceita estes Termos de Utilização. Se não concordar, deixe de utilizar o site." },
      { h: "2. Finalidade informativa", p: "O conteúdo deste website é disponibilizado apenas para fins comerciais e de informação geral. Não constitui aconselhamento médico, jurídico ou regulamentar, e nenhum conteúdo deve ser interpretado como uma alegação sobre produtos." },
      { h: "3. Disponibilidade dos produtos", p: "A disponibilidade, formulação, classificação e estatuto regulamentar dos produtos podem variar consoante o país. Nada neste website constitui uma oferta de venda de qualquer produto numa jurisdição específica." },
      { h: "4. Propriedade intelectual", p: "O nome NORTIS, a identidade visual e o conteúdo do website são propriedade da NORTIS. Não pode reproduzir nem distribuir o conteúdo do site sem autorização prévia por escrito." },
      { h: "5. Limitação de responsabilidade", p: "A NORTIS envida esforços razoáveis para manter a exatidão das informações do website, mas não garante a sua integralidade. Na medida permitida por lei, a NORTIS não é responsável por decisões tomadas com base no conteúdo do website." },
      { h: "6. Ligações de terceiros", p: "Este website pode conter ligações para recursos de terceiros. A NORTIS não é responsável pelo conteúdo nem pelas práticas de sites externos." },
      { h: "7. Vigência dos termos", p: "Estes termos podem ser atualizados periodicamente. A utilização continuada do website constitui a aceitação da versão em vigor." },
    ],
  },
  seo: {
    home: { title: "NORTIS — Soluções ODF avançadas | Parceiro em películas orodispersíveis", desc: "A NORTIS liga produtos inovadores de películas orodispersíveis (ODF) a marcas, parceiros e mercados em todo o mundo. Distribuição, marca própria e desenvolvimento de mercados." },
    tech: { title: "Tecnologia ODF — NORTIS", desc: "Uma perspetiva educativa sobre a tecnologia das películas orodispersíveis: formato, estrutura, experiência do utilizador e possibilidades comerciais." },
    solutions: { title: "Portefólio de soluções ODF — NORTIS", desc: "Explore as categorias de soluções ODF: bem-estar diário, energia, beleza, sono, ingredientes funcionais e conceitos de marca própria à medida." },
    partnership: { title: "Marca própria e distribuição — NORTIS", desc: "Torne-se parceiro da NORTIS através dos modelos de distribuição, marca própria ou desenvolvimento de mercados para produtos ODF." },
    about: { title: "Sobre a NORTIS — Focados no formato do amanhã", desc: "A NORTIS liga inovações ODF promissoras às marcas, parceiros e mercados capazes de as transformar em produtos comerciais." },
    contact: { title: "Contactar a NORTIS — Iniciar uma conversa", desc: "Contacte a equipa da NORTIS para falar sobre distribuição ODF, marca própria, sourcing ou desenvolvimento de mercados." },
    privacy: { title: "Política de Privacidade — NORTIS", desc: "Como a NORTIS recolhe, utiliza e protege as informações submetidas através deste website." },
    terms: { title: "Termos de Utilização — NORTIS", desc: "Termos que regem a utilização do website da NORTIS e do seu conteúdo informativo." },
  },
  a11y: {
    mainNav: "Navegação principal",
    mobileNav: "Navegação móvel",
    homeLink: "Início da NORTIS",
    openMenu: "Abrir menu",
    closeMenu: "Fechar menu",
    langSelector: "Selecionar idioma",
    filmDiagram: "Diagrama interativo das camadas da película",
    linkedinLabel: "NORTIS no LinkedIn",
    techImageAlt: "Lâminas de película sobrepostas abstratas",
    yes: "Sim",
    partial: "Parcial",
    no: "Não",
    filters: "Filtros de soluções",
  },
  solutionsData: {
    "daily-wellness": {
      name: "Bem-estar diário",
      desc: "Conceitos de películas para o dia a dia, concebidos para se integrarem naturalmente nas rotinas modernas da manhã e da noite.",
      possibilities: ["Linhas de produto baseadas em rotinas", "Formatos adequados a subscrições", "Embalagem premium minimalista"],
      positioning: "Posicionado para consumidores que procuram uma consistência diária sem esforço.",
      availability: "Em desenvolvimento com parceiros",
      targetMarket: "Retalho de bem-estar e estilo de vida",
      docStatus: "Preparada por mercado",
    },
    "energy-performance": {
      name: "Energia e desempenho",
      desc: "Conceitos para levar, destinados a consumidores que valorizam o dinamismo — antes do treino, de uma viagem ou de um dia exigente.",
      possibilities: ["Posicionamento pré-atividade", "Formatos multipack compactos", "Linguagem de marca arrojada e moderna"],
      positioning: "Criado para momentos de consumo rápidos e orientados para a conveniência.",
      availability: "Em desenvolvimento com parceiros",
      targetMarket: "Canais de vida ativa e desporto",
      docStatus: "Preparada por mercado",
    },
    "beauty-aging": {
      name: "Beleza e envelhecimento saudável",
      desc: "Conceitos de películas elegantes para a categoria da beleza de dentro para fora, onde a experiência e a estética contam.",
      possibilities: ["Posicionamento de beleza premium", "Conceitos de embalagem para oferta", "Storytelling de marca centrado no ritual"],
      positioning: "Um formato refinado para marcas que elevam o ritual de beleza diário.",
      availability: "Em desenvolvimento com parceiros",
      targetMarket: "Beleza de dentro para fora e retalho premium",
      docStatus: "Preparada por mercado",
    },
    "sleep-relaxation": {
      name: "Sono e relaxamento",
      desc: "Conceitos serenos, orientados para a noite, concebidos em torno da simplicidade no final do dia.",
      possibilities: ["Posicionamento como ritual noturno", "Formatos discretos para a mesa de cabeceira", "Design sensorial relaxante"],
      positioning: "Criado para o momento de calma que antecede o descanso.",
      availability: "Em desenvolvimento com parceiros",
      targetMarket: "Bem-estar noturno e retalho de farmácia",
      docStatus: "Preparada por mercado",
    },
    "vitamins-functional": {
      name: "Vitaminas e ingredientes funcionais",
      desc: "Conceitos de películas construídos em torno de ingredientes funcionais reconhecidos, apresentados num formato moderno e preciso.",
      possibilities: ["Famílias de produtos centradas nos ingredientes", "Design de rótulo claro e honesto", "Diferenciação através do formato"],
      positioning: "Uma alternativa contemporânea em categorias de ingredientes consolidadas.",
      availability: "Em desenvolvimento com parceiros",
      targetMarket: "Retalho nutracêutico e funcional",
      docStatus: "Preparada por mercado",
    },
    "custom-private-label": {
      name: "Conceitos à medida e de marca própria",
      desc: "Uma tela em branco: conceitos ODF à medida, desenvolvidos sob a marca do parceiro, da ideia ao lançamento.",
      possibilities: ["Desenvolvimento de conceitos totalmente à medida", "Coordenação de marca e embalagem", "Apoio ao lançamento e à escalada"],
      positioning: "Para parceiros que querem um produto diferenciado e inconfundivelmente seu.",
      availability: "Aberto a propostas",
      targetMarket: "Detentores de marcas e retalhistas",
      docStatus: "Definida por projeto",
    },
  },
};
